export enum EstadoDocumentoEnum {
    SIN_ADJUNTAR = 'SIN_ADJUNTAR',
    TRABAJANDO = 'TRABAJANDO',
    SIN_GUARDAR = 'SIN_GUARDAR',
    GUARDADO = 'GUARDADO'
}
